import { backendLabelOf, type BackendName } from '@littlebird/ui-utils';
import { observer } from 'mobx-react-lite';

import { cn } from '@/lib/utils';
import { userStore } from '@/stores/user.store';

type StaffBackendLabelProps = {
  // Null when the server did not say which backend made it
  backend: BackendName | null;
  className?: string;
};

/** Names the backend that made a routine run or an action card; only internal users see it, as they see the Backend setting */
export const StaffBackendLabel = observer(
  ({ backend, className }: StaffBackendLabelProps) => {
    if (!backend || !userStore.isInternalUser) return null;

    return (
      <span
        title="The backend that made this. You see it because you are internal."
        className={cn('shrink-0 whitespace-nowrap', className)}
      >
        {backendLabelOf(backend)}
      </span>
    );
  }
);
